<template>
  <div>
    <p class="tw:mb-6" v-html="$t('rc_pause_flow_reminder_info')" />
    <p v-html="$t(campaignType === 'cpc' ? 'rc_pause_flow_support_cpc' : 'rc_pause_flow_support')" />
  </div>
</template>
<script setup>
defineProps({
  campaignType: String,
})
</script>
<style scoped>
p :deep(a) {
  color: var(--tw-color-blue-700);
  text-decoration-line: underline;
}
p :deep(a):hover {
  color: var(--tw-color-blue-800);
  text-decoration-line: underline;
}
</style>
